module.exports = __webpack_public_path__ + "static/bg-9cf3ce5f1fb06f759c6922a47d215dfd.jpg";